export const TASK_SCHEMA_VERSION = 1;

export function normalizeTaskPayload(raw) {
  const isEvent = raw && (
    Object.hasOwn(raw, "task") ||
    Object.hasOwn(raw, "event_id") ||
    Object.hasOwn(raw, "data")
  );
  const envelope = isEvent
    ? raw
    : { schema_version: raw?.schema_version ?? 1, task: raw };
  if (envelope.schema_version !== TASK_SCHEMA_VERSION) {
    const error = new Error(`Unsupported task schema: ${envelope.schema_version}`);
    error.code = "TASK_SCHEMA_UNSUPPORTED";
    throw error;
  }

  const task = envelope.data ?? envelope.task ?? null;
  if (task === null) {
    return { ...envelope, task: null };
  }

  return {
    ...envelope,
    task: {
      ...task,
      id: Number(task.id),
      version: Number(task.version ?? envelope.version ?? 1),
      machine: task.machine ?? null,
      cycle: task.cycle ?? null,
      source: task.source ?? null,
      participants: Array.isArray(task.participants) ? task.participants : [],
    },
  };
}
